import classNames from 'classnames';
import * as React from 'react';
import {Form} from 'react-bootstrap';
import {defineMessages, FormattedMessage, useIntl} from 'react-intl';

import styles from './TextInputBox.less';
import {ConfigObjectType} from 'src/js/common/types';
import {TranslateUtils} from 'src/js/common/utils';
import {ProgressTick, SubmitButton} from 'src/js/components';

const I18N = defineMessages({
  SUBMIT: {
    id: 'textInput.button.submit',
    defaultMessage: 'Submit',
    description: 'text for text input submit button',
  },
});

interface OwnProps {
  config: ConfigObjectType;
  handleTextChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  handleSubmitClick: (event: React.UIEvent<HTMLButtonElement>) => void;
  isInvalidInput: boolean;
  submittingCounter?: number;
  text: string;
}

type Props = OwnProps;

export const TextInputBox: React.FC<Props> = (props) => {
  const {
    handleSubmitClick,
    handleTextChange,
    isInvalidInput,
    submittingCounter = 0,
    text,
  } = props;
  const intl = useIntl();

  return (
    <div className={styles.dlTextInputBox}>
      <div className={styles.dlTwoColumnsWrapper}>
        <div
          className={classNames({
            [styles.dlTextAreaWrapper]: true,
          })}
        >
          <Form.Control
            autoFocus
            as='textarea'
            className={classNames({
              [styles.dlTextAreaInput]: true,
              [styles.dlVResize]: true,
              [styles.dlInvalidInput]: isInvalidInput,
              dlFontNormal: true,
            })}
            rows={3}
            spellCheck={'false'}
            value={text}
            onChange={handleTextChange}
          />
          <SubmitButton
            className={classNames({
              [styles.dlTextAreaButton]: true,
              btn: true,
              'btn-primary': true,
            })}
            onClick={handleSubmitClick}
            title={TranslateUtils.translate(I18N.SUBMIT, intl)}
            disabled={isInvalidInput}
          >
            <ProgressTick progressCounter={submittingCounter}>
              <FormattedMessage {...I18N.SUBMIT} />
            </ProgressTick>
          </SubmitButton>
        </div>
      </div>
    </div>
  );
};

TextInputBox.displayName = 'TextInputBox';
